function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M9.756 4.297A2.61 2.61 0 0112 3c.916 0 1.765.49 2.243 1.297l7.406 12.674c.465.826.468 1.844.007 2.673A2.614 2.614 0 0119.4 21H4.59a2.61 2.61 0 01-2.248-1.356 2.75 2.75 0 01.014-2.686l7.4-12.66zm-5.893 13.57a.915.915 0 00-.002.89.867.867 0 00.74.452h14.788a.87.87 0 00.75-.452.91.91 0 00.004-.878L12.746 5.222A.87.87 0 0012 4.79a.87.87 0 00-.746.43l-7.39 12.645zm7.263-8.507c0-.495.391-.896.874-.896.482 0 .873.401.873.896v3.581a.885.885 0 01-.873.896.885.885 0 01-.874-.896V9.36zm.256 6.9a.911.911 0 010-1.266.859.859 0 011.235 0 .911.911 0 010 1.267.859.859 0 01-1.235 0z"
});

var SvgAlertTriangle = function SvgAlertTriangle(props) {
  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/alert-triangle.cc90d9bf.svg";
export { SvgAlertTriangle as ReactComponent };